import React, { useContext, useEffect } from "react";
import { Snackbar, Tab, Tabs } from "@origin-digital/ods-core";
import MessagesTabContent from "./Messages/MessagesTabContent";
import { MessageContext } from "./Messages/MessageContext";
import { IMessageMetadata } from "./Messages/types";
import { useSearchParams } from "react-router-dom";
import { AppContext } from "../../context/AppContext";
import { apiClient } from "../../api/apiService";
import { MessageDirectionEnum } from "../Premises/types";

const LodgedServiceWrapper = ({
  messageMetadata,
  blockRefId,
  children,
}: {
  messageMetadata: IMessageMetadata;
  blockRefId: string;
  children: React.ReactNode;
}) => {
  const {
    requestId,
    journeyId,
    rawRequestStatus,
    latestMessageDirection,
    latestMessageProcessed,
    latestMessageType,
    hasUnreadMessageForUser,
    messagePause: latestMessagePaused,
    type,
    messageEnabled,
  } = messageMetadata;
  const {
    context: { user },
  } = useContext(AppContext);
  const { messageTabState, setMessageTabState } = useContext(MessageContext);
  const { displaySnackbar, messageRecords, messagePause, actionButtonRef } =
    messageTabState;
  const [searchParams] = useSearchParams();
  const defaultToMessageTab = searchParams.get("message");

  useEffect(() => {
    setMessageTabState((prevMessageTabState) => ({
      ...prevMessageTabState,
      requestId,
      journeyId,
      rawRequestStatus,
      latestMessageDirection,
      latestMessageProcessed,
      latestMessageType,
      hasUnreadMessageForUser,
      messagePause: latestMessagePaused,
      type,
      blockRefId,
    }));
  }, []);

  const scrollActionButtonsIntoView = () => {
    if (blockRefId && actionButtonRef && actionButtonRef?.current) {
      setTimeout(() => {
        actionButtonRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "end",
        });
        setMessageTabState((prevMessageTabState) => ({
          ...prevMessageTabState,
          processingMessageTabClicked: false,
        }));
      }, 400);
    } else {
      setMessageTabState((prevMessageTabState) => ({
        ...prevMessageTabState,
        processingMessageTabClicked: false,
      }));
    }
  };

  const onSnackBarClosed = () => {
    setMessageTabState((prevMessageTabState) => ({
      ...prevMessageTabState,
      displaySnackbar: undefined,
    }));
  };

  const onMessageTabClicked = async () => {
    const latestMessageId =
      messageRecords.length > 0
        ? messageRecords[messageRecords.length - 1]?.id
        : null;
    const isLatestOutboundMessageUnProcessed =
      latestMessageId &&
      latestMessageDirection === MessageDirectionEnum.OUTBOUND &&
      latestMessageProcessed === false;
    if (
      user?.role === "USER" &&
      isLatestOutboundMessageUnProcessed &&
      !messagePause
    ) {
      await apiClient.post(`/message/markAsRead/${latestMessageId}`);
      setMessageTabState((prevMessageTabState) => ({
        ...prevMessageTabState,
        latestMessageProcessed: true,
      }));
    }
    setMessageTabState((prevMessageTabState) => ({
      ...prevMessageTabState,
      processingMessageTabClicked: true,
    }));
    scrollActionButtonsIntoView();
  };
  if (!messageEnabled) {
    return <>{children}</>;
  }
  return (
    <>
      <Tabs
        defaultValue={defaultToMessageTab ? 1 : 0}
        id="tabs"
        variant="scrollable"
      >
        <Tab data-id="request-tab" label="Request">
          {children}
        </Tab>

        <Tab
          data-id="messages-tab"
          label="Messages"
          muiProps={{ onClick: onMessageTabClicked }}
        >
          <MessagesTabContent />
        </Tab>
        {/*<Tab data-id="tab2" label="Progress"></Tab>*/}
      </Tabs>
      {displaySnackbar && (
        <Snackbar
          open
          tone={displaySnackbar.tone}
          showClose
          autoHideDuration={5000}
          align="left"
          onClose={onSnackBarClosed}
        >
          {displaySnackbar.message}
        </Snackbar>
      )}
    </>
  );
};

export default LodgedServiceWrapper;
